/* global RoiCalendar */
import EngineWidget from './engine-widget';

export default class EngineWidgetModal {
    constructor(engineWidget, trigger) {
        this._engineWidget = engineWidget;
        this._trigger = trigger;
        this._overlay = RoiCalendar.getOverlay(this._onModalClose.bind(this));
        this._keepScrollDisabled = this._keepScrollDisabled.bind(this);
        this._formClone = this._engineWidget.getFormTemplate();

        this._cloneWidget();
        this._launch(this);
    }

    _cloneWidget() {
        const container = document.createElement('div');
        container.classList.add('roi-search-engine');
        container.classList.add('roi-search-engine__modal');
        container.classList.add('roi-search-engine--vertical');
        this._isDropdown(container);
        container.setAttribute('role', 'dialog');
        container.setAttribute('aria-modal', 'true');
        container.appendChild(this._formClone);
        this._formClone.classList.remove('roi-search-engine__form--shadow');

        new EngineWidget(this._formClone, this._prepareInitialData());
        this._overlay.setContent(container);
        this._overlay.addClass('overlay-with-engine');
    }

    static _checkPromoCode() {
        const checkCodPromo = document.querySelectorAll('.roi-search-engine__item--suggested-promocode'),
            codPromoInput = document.querySelectorAll('.js-roi-search-engine-promo'),
            checkCodPromoInput = document.querySelectorAll('.roi-search-engine__field--suggested-promocode');
        if (checkCodPromo && checkCodPromo.length > 1) {
            checkCodPromoInput[1].addEventListener('change', (event) => {
                if (event.target.checked) {
                    codPromoInput[1].value = event.target.dataset.promocode;
                } else {
                    codPromoInput[1].value = '';
                }
            });
        }
    }

    _keepScrollDisabled() { this._overlay.disableScroll(); }

    _launch() {
        this._overlay.show();
        document.body.addEventListener('RoiOverlayHidden', this._keepScrollDisabled);
        this.constructor._checkPromoCode();
        document.querySelectorAll('.js-roicalendar-trigger').forEach((item) => {
            item.addEventListener('click', (event) => {
                if (event.target.closest('.js-roi-overlay')) {
                    const calendarElement = document.querySelector('#roicalendar');
                    calendarElement.style = '';
                }
            });
        });
    }

    _onModalClose() {
        document.body.removeEventListener('RoiOverlayHidden', this._keepScrollDisabled);
        this._overlay.hide();
    }

    _prepareInitialData() {
        return {
            asModal: true,
            hotelCode: this._trigger.dataset.hotelCod,
            hotelName: this._trigger.dataset.hotel
        };
    }

    _isDropdown(container) {
        this._isOccupancyDropdown = document.querySelector('.roi-search-engine-occupancy--v2');
        this._isDestinationDropdown = document.querySelector('.js-roi-search-engine-advanced-destination-v2');
        if (this._isOccupancyDropdown || this._isDestinationDropdown) {
            container.classList.add('roi-search-engine--occupancy-dropdown');
        }
    }
}
